<template>
  <div>
    <hr />
    <DataTable
      :data="diaginters"
      :columns="columnas"
      idField="idDiagInter"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarVer="false"
      :mostrarEditar="true"
      :mostrarEliminar="true"
      mensajeVacio="No hay diagnósticos registrados."
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idDiagInter)"
      @delete="row => deleteDiagInter(row.idDiagInter)"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="modalDiagLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalDiagLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">
              <!-- Diagnóstico -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Diagnóstico</label>
                  </div>
                  <div class="col-10">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchTextDiag"
                        @input="filterDiagnosticos"
                        @keyup.enter="toggleDropdown"
                        placeholder="Buscar diagnóstico..."
                      />
                      <button
                        class="btn btn-outline-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ref="dropdownButton"
                      >
                        <span class="material-symbols-outlined" style="font-size:16px">search</span>
                      </button>
                      <ul
                        class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height: 250px; overflow-y: auto; width: 100%;"
                        ref="dropdownMenu"
                      >
                        <li v-for="diagnostico in filteredDiagnosticos" :key="diagnostico.idDiagnostico">
                          <a
                            class="dropdown-item text-truncate"
                            href="#"
                            @click.prevent="selectDiagnostico(diagnostico)"
                            :title="diagnostico.nombre"
                          >
                            {{ diagnostico.nombre }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Tipo -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Tipo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoDiagInter.tipo">
                      <option value="" disabled>Seleccione una opción</option>
                      <option value="Presuntivo">Presuntivo</option>
                      <option value="Definitivo">Definitivo</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Observación -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Observación</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      v-model="datoDiagInter.observacion"
                      style="text-transform: uppercase"
                      maxlength="250"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click.prevent="guardarDiagInter"
            >
              <span class="material-symbols-outlined">save</span> Guardar
            </button>
            <button
              v-if="btnEditar"
              type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click.prevent="guardarEditDiagInter"
            >
              <span class="material-symbols-outlined">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import DataTable from '@/components/DataTable.vue'
import api from '@/services/api'
import { openModal } from '@/modules/modalHelper.js'
import swal from 'sweetalert'

// FIX: importar Modal de bootstrap en lugar de usar el global window.bootstrap
import { Modal } from 'bootstrap'

export default {
  components: { DataTable },
  props: {
    p_idInformeInter: { type: Number, required: true },
  },
  data() {
    return {
      diaginters:           [],
      datoDiagInter:        {},
      titulo:               '',
      btnCrear:             false,
      btnEditar:            false,
      modalWindow:          true,
      diagnosticos:         [],
      filteredDiagnosticos: [],
      searchTextDiag:       '',
      columnas: [
        { field: 'tipo',               label: 'Tipo' },
        { field: 'diagnosticoCodigo',  label: 'Código' },
        { field: 'diagnosticoNombre',  label: 'Nombre' },
        { field: 'observacion',        label: 'Observación' },
      ],
    }
  },
  mounted() {
    this.getData()
    this.fetchDiagnosticos()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    // Obtener instancia del modal de forma segura
    getModalInstance() {
      const el = document.getElementById('ventanaModal')
      return el ? Modal.getInstance(el) ?? new Modal(el) : null
    },
    getData() {
      api.get('/vwdiaginters/idinformeinter/' + this.p_idInformeInter)
        .then(response => { this.diaginters = response.data.reverse() })
        .catch(error => console.error('Error al obtener diagnósticos:', error))
    },
    validarFormLocal() {
      const fields = ['idDiagnostico', 'tipo', 'observacion']
      return validarForm(this.datoDiagInter, fields, fields)
    },
    async guardarDiagInter() {
      if (this.validarFormLocal() !== 1) return
      try {
        this.datoDiagInter.idInformeInter = this.p_idInformeInter
        await api.post('/diaginters', this.datoDiagInter)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Diagnóstico registrado exitosamente!', 'success')
        this.getData()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },
    async guardarEditDiagInter() {
      if (this.validarFormLocal() !== 1) return
      try {
        await api.post('/diaginters', this.datoDiagInter)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Diagnóstico actualizado exitosamente!', 'success')
        this.getData()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    abrirModalCrear() {
      this.modalWindow    = true
      this.datoDiagInter  = {}
      this.searchTextDiag = ''
      this.titulo         = 'Registrar Diagnóstico'
      this.btnCrear       = true
      this.btnEditar      = false
      openModal('ventanaModal')
    },
    abrirModalEditar(idDiagInter) {
      this.modalWindow = true
      if (idDiagInter) {
        api.get('/vwdiaginters/' + idDiagInter).then(resp => {
          this.datoDiagInter  = resp.data
          this.searchTextDiag = `${resp.data.diagnosticoCodigo} - ${resp.data.diagnosticoNombre}`
        })
      }
      this.titulo    = 'Editar Diagnóstico'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },
    async deleteDiagInter(idDiagInter) {
      try {
        await api.delete('/diaginters/' + idDiagInter)
        this.getData()
      } catch (error) {
        swal('Error!', 'No se pudo eliminar el registro.', 'error')
      }
    },
    fetchDiagnosticos() {
      api.get('/vwdiagnosticos')
        .then(response => {
          this.diagnosticos         = response.data
          this.filteredDiagnosticos = response.data
        })
        .catch(error => console.error('Error fetching diagnósticos:', error))
    },
    filterDiagnosticos() {
      this.filteredDiagnosticos = this.diagnosticos.filter(d =>
        d.nombre.toLowerCase().includes(this.searchTextDiag.toLowerCase())
      )
    },
    selectDiagnostico(diagnostico) {
      this.datoDiagInter.idDiagnostico = diagnostico.idDiagnostico
      this.searchTextDiag = `${diagnostico.codigo} - ${diagnostico.nombre}`
    },
    toggleDropdown() {
      this.$refs.dropdownButton.click()
    },
  },
}
</script>